module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_studio-6cc23675e6a9a4796f0b9062e6ff595c.jpg";